import { CSSProperties } from 'react'

export type Icons =
  | '18607'
  | 'beige'
  | '18601'
  | 'blue'
  | '18604'
  | 'brown'
  | '18640'
  | 'yellow'
  | '18613'
  | 'grey'
  | '18616'
  | 'green'
  | '18643'
  | 'purple'
  | '18637'
  | 'multicoloured'
  | '18631'
  | 'orange'
  | '18628'
  | 'red'
  | '18625'
  | 'black'
  | '18634'
  | 'black/white'
  | '18610'
  | 'taupe'
  | '18622'
  | 'turquoise'
  | '18619'
  | 'white'
  | '18598'
  | 'pink'

export type Props = {
  name: Icons
  className?: string
  viewBox?: string
  setWidth?: number
  setHeight?: number
  style?: CSSProperties
}

export const ColorIcon = ({
  name,
  className = '',
  viewBox,
  setWidth,
  setHeight = setWidth,
  style,
}: Props) => {
  const StandardColorSVG = (color: string) => {
    return {
      width: 24,
      height: 24,
      icon: (
        <>
          <circle cx="12" cy="12" r="12" fill={color} />
        </>
      ),
    }
  }

  const selectIcon = () => {
    switch (name) {
      case '18607':
      case 'beige':
        return StandardColorSVG('#E6DAC6')
      case '18601':
      case 'blue':
        return StandardColorSVG('#697CA0')
      case '18604':
      case 'brown':
        return StandardColorSVG('#946441')
      case '18640':
      case 'yellow':
        return StandardColorSVG('#E1B861')
      case '18613':
      case 'grey':
        return StandardColorSVG('#D9D9D9')
      case '18616':
      case 'green':
        return StandardColorSVG('#87957F')
      case '18643':
      case 'purple':
        return StandardColorSVG('#7E6379')
      case '18628':
      case 'red':
        return StandardColorSVG('#BE3F3F')
      case '18625':
      case 'black':
        return StandardColorSVG('#141414')
      case '18610':
      case 'taupe':
        return StandardColorSVG('#9E8B80')
      case '18622':
      case 'turquoise':
        return StandardColorSVG('#889F9E')
      case '18598':
      case 'pink':
        return StandardColorSVG('#C77A80')
      case '18631':
      case 'orange':
        return StandardColorSVG('#CF7046')
      case '18619':
      case 'white':
        return {
          height: 24,
          width: 24,
          icon: (
            <>
              <circle
                cx="12"
                cy="12"
                r="11.5"
                fill="url(#paint0_radial_4172_26708)"
                stroke="#CACACA"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_4172_26708"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(12 12) rotate(90) scale(12)"
                >
                  <stop offset="0.0104167" stopColor="white" />
                  <stop offset="1" stopColor="white" />
                </radialGradient>
              </defs>
            </>
          ),
        }
      case '18637':
      case 'multicoloured':
        return {
          height: 24,
          width: 24,
          icon: (
            <>
              <path
                d="M11.9997 0V12L3.51221 3.5125C5.68721 1.34167 8.68721 0 11.9997 0Z"
                fill="#E1B961"
              />
              <path
                d="M20.4875 3.5125L12 12V0C15.3125 0 18.3125 1.34167 20.4875 3.5125Z"
                fill="#7B8874"
              />
              <path
                d="M24 12H12L20.4875 3.51248C22.6583 5.68748 24 8.68748 24 12Z"
                fill="#83A8A6"
              />
              <path
                d="M24 12C24 15.3125 22.6583 18.3125 20.4875 20.4833L12 12H24Z"
                fill="#798AAA"
              />
              <path
                d="M20.4875 20.4833C18.3125 22.6583 15.3125 24 12 24V12L20.4875 20.4833Z"
                fill="#7E6379"
              />
              <path
                d="M11.9997 12V24C8.68721 24 5.68721 22.6583 3.51221 20.4833L11.9997 12Z"
                fill="#BE3F3F"
              />
              <path d="M12 12L3.5125 20.4833C1.34167 18.3125 0 15.3125 0 12H12Z" fill="#C77A80" />
              <path d="M12 12H0C0 8.68748 1.34167 5.68748 3.5125 3.51248L12 12Z" fill="#CF7046" />
            </>
          ),
        }
      case '18634':
      case 'black/white':
        return {
          height: 24,
          width: 24,
          icon: (
            <>
              <mask
                id="mask0_4214_96994"
                type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <circle cx="12" cy="12" r="11.5" fill="#CACACA" stroke="#CACACA" />
              </mask>
              <g mask="url(#mask0_4214_96994)">
                <rect width="12" height="25" fill="#141414" />
                <circle cx="12" cy="12" r="11.75" stroke="#CACACA" strokeWidth="0.5" />
              </g>
            </>
          ),
        }
      default:
        return { icon: null, width: 24, height: 24 }
    }
  }

  const { icon, width, height } = selectIcon()

  return (
    <svg
      className={className}
      viewBox={viewBox ? viewBox : `0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      width={setWidth || width}
      height={setHeight || height}
      style={{ color: 'inherit', ...style }}
    >
      {icon}
    </svg>
  )
}
